// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestQuotePage {
  width: 100%;
  min-height: 100vh;
}

.adv-form-container {
  width: 100%;
  box-sizing: border-box;
  padding: 28px;
}

.adv-form-section-title {
  font-family: "Inter", sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #48d1cc;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 8px;
}

.adv-form-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 640px) {
  .adv-form-grid-2 {
    grid-template-columns: 1fr;
  }
}

.adv-btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: requestQuoteBtnSpin 0.8s linear infinite;
  display: inline-block;
}

@keyframes requestQuoteBtnSpin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/RequestQuotePage/RequestQuotePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,mDAAmD;EACnD,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".RequestQuotePage {\n  width: 100%;\n  min-height: 100vh;\n}\n\n.adv-form-container {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 28px;\n}\n\n.adv-form-section-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #48d1cc;\n  margin-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding-bottom: 8px;\n}\n\n.adv-form-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 640px) {\n  .adv-form-grid-2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.adv-btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: requestQuoteBtnSpin 0.8s linear infinite;\n  display: inline-block;\n}\n\n@keyframes requestQuoteBtnSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
